import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import notify from "../../components/notifier";
import userService from "../../services/user";
import { Button, Container, Row, Col } from "reactstrap";
import OwlCarousel from "react-owl-carousel";
import MEDIA_URL from "../../contants";

const LiveCasinoList = (props) => {
  const [games, setGames] = useState([]);
  const [Carousal, setCarousal] = useState(false);
  const [listType, setListType] = useState('');
  const showEvolution = (data) => {

    const getPlayerInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    if (
      getPlayerInfo === null ||
      getPlayerInfo.user.PortalName !== "Batman247"
    ) {
      notify("First login then open Casino", "error", "top-right");
      return;
    }

    let gameCode = "";
    if (data === "HyperGammon") {
      gameCode = "TVBET-1";
    } else if (data === "WheelBet") {
      gameCode = "TVBET-2";
    } else if (data === "5bet") {
      gameCode = "TVBET-6";
    } else if (data === "7bet") {
      gameCode = "TVBET-7";
    } else if (data === "FruitRace") {
      gameCode = "TVBET-14";
    } else if (data === "AndarBahar") {
      const url = window.location.origin + "/Casino/EZ/228000";
      window.open(url, "_self");
      return;
    } else if (data === "Aviator") {
      const url = window.location.origin + "/Casino/SPB/aviator";
      window.open(url, "_self");
      return;
    } else if (data === "keno") {
      gameCode = "TVBET-9";
    } else if (data === "lucky6") {
      gameCode = "TVBET-12";
    } else if (data === "PokerBet") {
      const url = window.location.origin + "/Casino/EZ/507000";
      window.open(url, "_self");
      return;
    } else if (data === "TeenPatti") {
      const url = window.location.origin + "/Casino/EZ/227103";
      window.open(url, "_self");
      return;
    } else if (data === "WarOfElements") {
      gameCode = "TVBET-5";
    } else if (data === "Joker") {
      gameCode = "TVBET-8";
    } else if (data === "32-cards") {
      const url = window.location.origin + "/Casino/SN/C32";
      window.open(url, "_self");
      return;
    } else if (data === "7UpDown") {
      const url = window.location.origin + "/Casino/EZ/228001";
      window.open(url, "_self");
      return;
    } else if (data === "BollywoodCasino") {
      const url = window.location.origin + "/Casino/QT/no";
      window.open(url, "_self");
      return;
    } else if (data === "EZUGI-BaccaratDragonTiger_150") {
      const url = window.location.origin + "/Casino/EZ/150";
      window.open(url, "_self");
      return;
    } else if (data === "Worli-Matka") {
      const url = window.location.origin + "/Casino/SN/VWM";
      window.open(url, "_self");
      return;
    } else if (data === "Roulette") {
      const url = window.location.origin + "/Casino/EZ/221005";
      window.open(url, "_self");
      return;
    } else if (data === "AmarAkbarAnthony") {
      const url = window.location.origin + "/Casino/SN/ARW";
      window.open(url, "_self");
      return;
    } else if (data === "Baccarot") {
      const url = window.location.origin + "/Casino/SN/BAC";
      window.open(url, "_self");
      return;
    } else if (data === "BlackJack") {
      const url = window.location.origin + "/Casino/EZ/51";
      window.open(url, "_self");
      return;
    } else if (data === "Fly high") {
      const url = window.location.origin + "/Casino/BGS/ATR";
      window.open(url, "_self");
      return;
    } else if (data === "Coin Toss") {
      const url = window.location.origin + "/Casino/BGS/HT";
      window.open(url, "_self");
      return;
    } else if (data === "Gold Rush") {
      const url = window.location.origin + "/Casino/BGS/GRSL";
      window.open(url, "_self");
      return;
    } else if (data === "Jungle Rumble") {
      const url = window.location.origin + "/Casino/BGS/JRSL";
      window.open(url, "_self");
      return;
    } else if (data === "Lucky Spin") {
      const url = window.location.origin + "/Casino/BGS/WOF";
      window.open(url, "_self");
      return;
    } else if (data === "Mermaid Beauty") {
      const url = window.location.origin + "/Casino/BGS/MBSL";
      window.open(url, "_self");
      return;
    } else if (data === "Vampire") {
      const url = window.location.origin + "/Casino/BGS/VVSL";
      window.open(url, "_self");
      return;
    } else if (data === "Wild West") {
      const url = window.location.origin + "/Casino/BGS/WWSL";
      window.open(url, "_self");
      return;
    } else if (data === "Fruity Reels"){
        const url = window.location.origin + "/Casino/7MJ/fr";
        window.open(url, "_self");
        return;
    } else if (data === "20 Hot Twist"){
        const url = window.location.origin + "/Casino/7MJ/20ht";
        window.open(url, "_self");
        return;
    } else if (data === "60 Ultra Classic Hot"){
        const url = window.location.origin + "/Casino/7MJ/60uch";
        window.open(url, "_self");
        return;
    } else if (data === "80 Fruit Dash"){
      const url = window.location.origin + "/Casino/7MJ/80fd";
      window.open(url, "_self");
      return;
    } else if (data === "Adventure Saga"){
      const url = window.location.origin + "/Casino/7MJ/as";
      window.open(url, "_self");
      return;
    } else if (data === "Age of Cleopatra"){
      const url = window.location.origin + "/Casino/7MJ/aoc";
      window.open(url, "_self");
      return;
    } else if (data === "Bandidos Showdown"){
      const url = window.location.origin + "/Casino/7MJ/bs";
      window.open(url, "_self");
      return;
    } else if (data === "Big 5 Africa"){
      const url = window.location.origin + "/Casino/7MJ/b5a";
      window.open(url, "_self");
      return;
    } else if (data === "Cook The Chef"){
      const url = window.location.origin + "/Casino/7MJ/ctc";
      window.open(url, "_self");
      return;
    } else if (data === "Dragon's Flower"){
      const url = window.location.origin + "/Casino/7MJ/df";
      window.open(url, "_self");
      return;
    } else if (data === "40 Fruity Reels"){
      const url = window.location.origin + "/Casino/7MJ/40fr";
      window.open(url, "_self");
      return;
    } else if (data === "Fortune Genie"){
      const url = window.location.origin + "/Casino/7MJ/fg";
      window.open(url, "_self");
      return;
    } else if (data === "Fruit Dash"){
      const url = window.location.origin + "/Casino/7MJ/fd";
      window.open(url, "_self");
      return;
    } else if (data === "Golden Vegas"){
      const url = window.location.origin + "/Casino/7MJ/gv";
      window.open(url, "_self");
      return;
    } else if (data === "Hot Fortune Wheel 80"){
      const url = window.location.origin + "/Casino/7MJ/hfw80";
      window.open(url, "_self");
      return;
    } else if (data === 'Virtual Cricket In play') {
      const url = window.location.origin + '/virtual-sports/BR/vci';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual Football world cup') {
      const url = window.location.origin + '/virtual-sports/BR/vfwc';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual tennis In play') {
      const url = window.location.origin + '/virtual-sports/BR/vti';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual Horses') {
      const url = window.location.origin + '/virtual-sports/BR/vhk';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual Dogs') {
      const url = window.location.origin + '/virtual-sports/BR/vdk';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual baseball Inplay') {
      const url = window.location.origin + '/virtual-sports/BR/vbi';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual Football Champions Cup') {
      const url = window.location.origin + '/virtual-sports/BR/vfcc';
      window.open(
        url,
        "_self"
      );  
      return;
    }
    // return;
    const url = window.location.origin + "/CasinoDetail/" + gameCode;
    // console.log('DATA =====', data, url)
    window.open(url, "_self");
  };
  
  useEffect(() => {
    let type = props && props.type;
    setListType(type)
    const hotgames = [
      {
        title: "Fly high",
        img: "F_y-high.png",
        type: "Flyhigh",
      },
      {
        title: "Coin Toss",
        img: "Coin-Toss.png",
        type: "CoinToss",
      },
      {
        title: "Gold Rush",
        img: "Gold-Rush.png",
        type: "GoldRush",
      },
      {
        title: "Jungle Rumble",
        img: "Jungle-rumble.png",
        type: "JungleRumble",
      },
      {
        title: "Lucky Spin",
        img: "Lucky-Spin.png",
        type: "LuckySpin",
      },
      {
        title: "Mermaid Beauty",
        img: "Mermaid-Beauty.png",
        type: "MermaidBeauty",
      },
      {
        title: "Vampire",
        img: "Vampire.png",
        type: "Vampire",
      },
      {
        title: "Wild West",
        img: "Wild-West.png",
        type: "WildWest",
      }
    ];
    const casinoArray = [
      {
        title: "AndarBahar",
        img: "andarbahar.gif",
        type: "AndarBahar",
      },
      {
        title: "TeenPatti",
        img: "teenpatti.gif",
        type: "TeenPatti",
      },
      {
        title: "PokerBet",
        img: "poker.gif",
        type: "PokerBet",
      },
      {
        title: "EZUGI-BaccaratDragonTiger_150",
        img: "dragontiger.gif",
        type: "Baccarat",
      },
      {
        title: "7UpDown",
        img: "7up7down.gif",
        type: "7UpDown",
      },
      {
        title: "32-cards",
        img: "32cards.gif",
        type: "32-cards",
      },
      {
        title: "Worli-Matka",
        img: "worlimatka.gif",
        type: "Worli-Matka",
      },
      {
        title: "BollywoodCasino",
        img: "bollywoodcasino.gif",
        type: "BollywoodCasino",
      },
      {
        title: "BlackJack",
        img: "blackjackbrusurest.gif",
        type: "BlackJack",
      },
      {
        title: "Baccarot",
        img: "bacacrtdeluxe.gif",
        type: "Baccarot",
      },
      {
        title: "Roulette",
        img: "roulettelobby.gif",
        type: "Roulette",
      },
    ];
    const slotgames = [
      {
        title: "20 Hot Twist",
        img: "20-Hot-Twist.png",
        type: "20 Hot Twist",
      },
      {
        title: "40 Fruity Reels",
        img: "40-Fruity-Reels.png",
        type: "Fruity Reels",
      },
      {
        title: "20 Hot Twist",
        img: "20-Hot-Twist.png",
        type: "20 Hot Twist",
      },
      {
        title: "60 Ultra Classic Hot",
        img: "60-Ultra-Classic-Hot.png",
        type: "60 Ultra Classic Hot",
      },
      {
        title: "80 Fruit Dash",
        img: "80-Fruit-Dash.png",
        type: "80 Fruit Dash",
      },
      {
        title: "Adventure Saga",
        img: "Adventure-Saga.png",
        type: "Adventure Saga",
      },
      {
        title: "Age of Cleopatra",
        img: "Age-of-Cleopatra.png",
        type: "Age of Cleopatra",
      },
      {
        title: "Bandidos Showdown",
        img: "Bandidos-Showdown.png",
        type: "Bandidos Showdown",
      },
      {
        title: "Big 5 Africa",
        img: "Big-5-Africa.png",
        type: "Big 5 Africa",
      },
      {
        title: "Cook The Chef",
        img: "Cook-The-Chef.png",
        type: "Cook The Chef",
      },
      {
        title: "Dragon's Flower",
        img: "Dragon_s-Flower.png",
        type: "Dragon's Flower",
      },
      {
        title: "Fruity Reels",
        img: "Fruity-Reels.png",
        type: "Fruity Reels",
      },
      {
        title: "Fortune Genie",
        img: "Fortune-Genie.png",
        type: "Fortune Genie",
      },
      {
        title: "Fruit Dash",
        img: "Fruit-Dash.png",
        type: "Fruit Dash",
      },
      {
        title: "Golden Vegas",
        img: "Golden-Vegas.png",
        type: "Golden Vegas",
      },
      {
        title: "Hot Fortune Wheel 80",
        img: "Hot-Fortune-Wheel-80.png",
        type: "Hot Fortune Wheel 80",
      }
    ];
    const virtualgames = [
      {
        title: "Virtual baseball Inplay",
        img: "Virtual-baseball-Inplay.png",
        type: "Virtual baseball Inplay",
      },
      {
        title: "Virtual Cricket In play",
        img: "Virtual-Cricket-In-play.png",
        type: "Virtual Cricket In play",
      },
      {
        title: "Virtual Dogs",
        img: "Virtual-Dogs.png",
        type: "Virtual Dogs",
      },
      {
        title: "Virtual Football Champions Cup",
        img: "Virtual-Football-Champions-Cup.png",
        type: "Virtual Football Champions Cup",
      },
      {
        title: "Virtual Football world cup",
        img: "Virtual-Football-world-cup.png",
        type: "Virtual Football world cup",
      },
      {
        title: "Virtual Horses",
        img: "Virtual-Horsess.png",
        type: "Virtual Horses",
      },
      {
        title: "Virtual tennis In play",
        img: "Virtual-tennis-In-play.png",
        type: "Virtual tennis In play",
      }
    ];
    let gameslist = '';
    if(!type || type == ''){
      gameslist = casinoArray;
    }else if (type && type == 'hotgames'){
      gameslist = hotgames;
    }else if (type && type == 'slotgames'){
      gameslist = slotgames;
    }else if (type && type == 'virtualgames'){
      gameslist = virtualgames;
    }
    if (props.data === "All") {
      setGames(gameslist.filter((a) => a.type !== "7mojos"));
    } else if (["Baccarat", "Roulette"].includes(props.data)) {
      setGames(gameslist.filter((f) => f.type === props.data));
    } else if (props.data === "7mojos") {
      // const mojosFil = ;
      setGames(gameslist.filter((f) => f.type === props.data));
    } else {
      setGames(gameslist);
    }

    if (props.is_carousal) {
      setCarousal(true);
    }
    const getPlayerInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  }, [props.data]);
  const options = {
    loop: true,
    dots: false,
    autoplay: true,
    margin: 10,
    nav: true,
    navText:['<img src="'+MEDIA_URL+'/web-images/left_icon.png" alt="" />','<img src="'+MEDIA_URL+'/web-images/right_icon.png" alt="" />'],
    responsive: {
      0: {
        items: 2.5,
      },
      600: {
        items: 3.5,
      },
      1000: {
        items: 6.5,
      },
    }
  };
  return (
    <>
      {!props.origin ? (
        <Container fluid>
          <Row className="mt-2">
            {games.map((data, idx) => (
              <Col
                key={idx}
                xs={6}
                sm={6}
                md={props.layout}
                className={`pr-1 pt-2 pl-1 cursor ${
                  props.origin ? props.origin : ""
                }`}
              >
                <img
                  alt={data.title}
                  title={data.title}
                  onClick={() => showEvolution(data.title)}
                  src={`${MEDIA_URL}/casino-gif/` + data.img}
                />
              </Col>
            ))}
          </Row>
        </Container>
      ) : (
        <Row className="m-0">
          {Carousal == true ? (
            <>
              <OwlCarousel
                className="portal-casino owl-theme"
                navContainerClass="live-nav-container"
                navClass={["live-prev","live-next"]}
                {...options}
              >
                {games.map((data, idx) => (
                  <div key={idx} className="casino-container-item">
                    <img
                      alt={data.title}
                      title={data.title}
                      onClick={() => showEvolution(data.title)}
                      src={`${MEDIA_URL}/casino-gif/` + data.img}
                  />
                  </div>
                ))}
              </OwlCarousel>
            </>
          ) : (
            games.map((data, idx) => (
              <Col
                key={idx}
                xs={6}
                sm={6}
                md={props.layout}
                className={`cursor ${props.origin ? props.origin : ""}`}
              >
                <img
                  alt={data.title}
                  title={data.title}
                  onClick={() => showEvolution(data.title)}
                  src={`${MEDIA_URL}/casino-gif/` + data.img}
                />
              </Col>
            ))
          )}
        </Row>
      )}
    </>
  );
};

export default withRouter(LiveCasinoList);
